import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2>Let’s Work Together -</h2>
        <div className="email"> 
          <img className="social-icon" src="/gmail.png"  alt="email" loading="lazy" /> 
          <a href="mailto:Georgy@gmail.com" className="mail">matrikabhatta062@gmail.com</a>
        </div> 
      </div>
      <div className="footer-links">
        <p className="copyright">© {new Date().getFullYear()} Matrika Bhatta . All rights reserved.</p>
        <div className="social-icons">
          <a href="https://github.com/MtRiX-x22"><img src="github.png" alt="Github" loading="lazy" onMouseOver={e => e.currentTarget.src = "github (1).png"} onMouseOut={e => e.currentTarget.src = "github.png"} style={{width: "30px", height: "30px" }} /></a>
          <a href="https://www.linkedin.com/in/matrika-bhatta-59374636b/"><img src="linkedin.png" alt="LinkedIn" loading="lazy" onMouseOver={e => e.currentTarget.src = "linkedin (1).png"} onMouseOut={e => e.currentTarget.src = "linkedin.png"} style={{width: "30px", height: "30px" }} /></a>
          <a href="https://www.instagram.com/mausam_vatta/"><img src="instagram.png" alt="Instagram" loading="lazy" onMouseOver={e => e.currentTarget.src = "instagram (1).png"} onMouseOut={e => e.currentTarget.src = "instagram.png"} style={{width: "30px", height: "30px" }} /></a>
          <a href="https://www.facebook.com/profile.php?id=61581482506319"><img src="facebook.png" alt="Facebook" loading="lazy" onMouseOver={e => e.currentTarget.src = "facebook (1).png"} onMouseOut={e => e.currentTarget.src = "facebook.png"} style={{width: "30px", height: "30px" }} /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
